import { http } from '@/lib/http';
import type { APIResponse } from '@/types';

export type GetShueishaIdAuthParamForWithdrawalResponse = APIResponse<{
  codeChallenge: string;
}>;

export const getShueishaIdAuthParamForWithdrawal = async () => {
  return await http<GetShueishaIdAuthParamForWithdrawalResponse>('/user/v1/shueisha-id/auth-param/withdrawal', {
    method: 'GET',
    query: {
      oem_service_id: process.env.NEXT_PUBLIC_SERVICE_ID,
    },
  });
};
